import React,{useEffect, useState} from 'react'
import DeleteConfirmationModal from './DeleteConfirmationModal';
import { useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { redirecturl } from '../../services/common/redirect';
import { CT_Events } from '../../analytics/CTEvents';
import MyAccountCardsShimmer from '../../ShimmerEffect/MyAccountShimmer';
import DeleteProfileCardShimmer from '../../ShimmerEffect/DeleteProfileCardShimmer';
import PageShimmer from '../../components/loader/skeletons/common/page-shimmer';
import ErrorMessage from '../../components/messaging/errormessage';
import { useTranslation } from 'react-i18next';

export default function MyAccount({pmsItem}) {
    const [showModal, setShowModal] = useState(false);
    const [result, setResult] = useState(null);
    const {t} = useTranslation();
    const { RatePlanType } = useSelector(
        (state) => state?.userdata?.value?.customerprofile
      );
    const {CT_ScreenView} = CT_Events();
    const {data: {data}={},
        isLoading,
        isFetching,
        isError,
        isLoadingError,
        error
    } = useQuery([
            {}, 
            pmsItem?.method,
            JSON.parse(pmsItem?.sourceid)
        ],
        {
            staleTime: 0,
            cacheTime: 0,
            onSuccess: ({data: udata})=>{
                if(udata?.status !== '-1'){
                    setResult(udata?.response?.dynamictypes?.[0]?.cards)
                }
            }
        })
    const handleClick = () =>{
        setShowModal(true);
    }
    const navigate = useNavigate();
    
    const togglebottomModal = () => {
        setShowModal(!showModal);
    }
    useEffect(()=>{
        try{
            CT_ScreenView("my_accounts")
        }catch{}
    }, [])

    if(isLoading || isFetching ){
        return <PageShimmer/> //<Loadingcomponent/>
    }
    if(error || isError || isLoadingError ){
        return <ErrorMessage message={t("Invalid")}/>
    }

    return (
        <div>
            <div className="pse_sm sprint16bg pt-5 pb-5">
            {(isLoading || isFetching ) ? <MyAccountCardsShimmer/>:
            <div className="sprint16-myacc-cards1">
                {result && result?.filter(obj => obj?.cardcode !== "RMDA")?.map(item => (
                    <div className="sprint16-myacc-card01" onClick={()=> redirecturl(item?.redirecturl, navigate, null, null, item)}>
                        <div className="s16-card01-left w-100">
                            <div className="img-div">
                                <img src={item?.imageurl} />
                            </div>
                            <div className="s16-card01-cont">
                                <h5>{item?.displaytext}</h5>
                                <p>{item?.description}</p>
                            </div>
                        </div>
                        <div className="right-arrow-btn">
                            <img src={process.env.PUBLIC_URL + '/assets/images/sprint16/right-arrow-button.svg'} />
                        </div>
                    </div>
                ))}
            </div>}

            {(isLoading || isFetching )? <DeleteProfileCardShimmer /> :result && result?.filter(obj => obj?.cardcode === "RMDA")?.map(item => (
            <div className="sprint16-myacc-cards2 mt-4">
                <div className="sprint16-myacc-card02">
                    <div className="s16-card01-left w-100">
                        <div className="s16-card01-cont">
                            <h5>{item?.displaytext}</h5>
                            <p>{item?.description}</p>
                        </div>
                    </div>
                    <div className="">
                        <button  onClick={handleClick}  class="custom_btn custom_btn_primary btn_block sp16_custom_btn">{item?.buttontext}</button>
                    </div>
                </div>
            </div>
            ))}
        </div>

        <DeleteConfirmationModal show={showModal} toggleModal={togglebottomModal} data={result?.filter(obj => obj?.cardcode === "RMDA")[0]?.metadata} buttontext={result?.filter(obj => obj?.cardcode === "RMDA")[0]?.buttontext}/>

        </div>
    )
}
